exports.install = function (Vue, spinner) {
  if (this.installed) {
    return
  }

  this.installed = true

  Vue.spinner = spinner

  Object.defineProperty(Vue.prototype, '$spinner', {
    get: function get () { return spinner }
  })
}



// WEBPACK FOOTER //
// ./src/configs/spinner/plugin.js